/**
 * SDK wrapper for visitor-identity APIs.
 * See https://github.com/NerdWallet/visitor-identity for details.
 */
import serviceHTTPHelper from './service-http-helper';

var VisitorIdentitySDK = function VisitorIdentitySDK(ServiceSDK, config) {
  var visitorIdentityBaseUrl = config.visitorIdentityBaseUrl;

  if (!visitorIdentityBaseUrl) {
    throw new Error('VisitoIdentitySDK requires a valid visitorIdentityBaseUrl');
  }

  function getVisitorIdentityRoute(namespace, version) {
    return function (endpoint) {
      return ServiceSDK.nwApiRoute(visitorIdentityBaseUrl, namespace, version, endpoint);
    };
  }

  var service = serviceHTTPHelper(ServiceSDK, getVisitorIdentityRoute('visitor-identity', 1));
  /**
   * Update the email for the logged out visitor identity
   * @param {String} newEmail - new email.
   * @param {Object} serverRequest - the current request.
   *
   * Example usage:
   *  sdk = VisitorIdentitySDK(serviceSDK, {visitorIdentityBaseUrl: ...});
   *  sdk.updateEmail('foo@bar.com', serverRequest).then(...)
   */

  function updateEmail(newEmail, serverRequest) {
    var data = {
      new_email: newEmail
    };
    return service.post('update_email', data, serverRequest);
  }
  /**
   * Register an email only registered user (EORU) (fka visitor).
   * @param {String} email - the EORU's email (required).
   * @param {Object} rtp - the registration tracking profile for this EORU (required).
   * @param {Object} serverRequest - the current request.
   *
   * Example usage:
   *  sdk = VisitorIdentitySDK(serviceSDK, {visitorIdentityBaseUrl: ...});
   *  sdk.register('foo@bar.com', {'page_impression_id': 'the_page_impression_id'}, serverRequest).then(...)
   */


  function register(email, rtp, serverRequest) {
    var data = {
      email: email,
      profiles: {
        registration_tracking_profile: rtp
      }
    };
    return service.post('register', data, serverRequest);
  }

  return {
    ServiceSDK: ServiceSDK,
    updateEmail: updateEmail,
    register: register
  };
};

export default VisitorIdentitySDK;